import { cn } from '@bw/core';
import { FC } from 'react';
import { FormName } from '../utils/formMap';
import { StartAnAgencyForm } from './start-an-agency/StartAnAgencyForm';

type Props = {
	name: FormName;
	className?: string;
};

export const Form: FC<Props> = ({ name, className, ...inpectorTags }) => {
	return (
		<div className={cn(className)} {...inpectorTags}>
			<FormContent name={name} />
		</div>
	);
};

const FormContent: FC<Props> = ({ name }) => {
	switch (name) {
		case 'Become an Agent': {
			return <StartAnAgencyForm />;
		}

		default: {
			return <></>;
		}
	}
};
